import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { rootRoute } from './root';
import { getSession } from '@/lib/auth-client';
import { consoleAccess } from '@/lib/console-admin';
import { PermissionProvider } from '@/lib/permissions';
import { RouteError } from '@/admin/ConsoleRouteError';
import { reportRenderError } from '@/lib/rum';

// The SDR-responsiveness review page. Lazy-loaded like /live so the cockpit's
// chunk never pays for it; admin-gated the same way, with the JWT riding
// per-request on the /bff/reports and /bff/transcripts calls.

function ResponsivenessGate() {
  const { userEmail, role } = responsivenessRoute.useRouteContext();
  return (
    <PermissionProvider role={role}>
      <LazyResponsivenessPage userEmail={userEmail} />
    </PermissionProvider>
  );
}

const LazyResponsivenessPage = lazyRouteComponent(() => import('@/admin/ResponsivenessPage'));

export const responsivenessRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/responsiveness',
  // Same gate as /console and /live: this page's /bff/reports/* reads are
  // admin-gated, so a non-admin would get an error wall rather than a page.
  beforeLoad: async () => {
    const { data } = await getSession();
    if (!data) throw redirect({ to: '/login' });
    const { allowed, role } = await consoleAccess();
    if (!allowed) throw redirect({ to: '/' });
    return { userEmail: data.user.email, role };
  },
  component: ResponsivenessGate,
  errorComponent: RouteError,
  onCatch: (error) => reportRenderError(error, 'route:responsiveness'),
});
